const inputs = document.querySelectorAll("input[type='text'], input[type='email'], input[type='password'], textarea");
const showPasswordCheckboxes = document.querySelectorAll(".showPasswordCheckbox");

// TODO check if we really need to import this from space.js
Array.from(inputs).forEach(input => {
    const inputArea = input.closest(".inputArea");

    if (!inputArea) {
        return;
    }

    input.addEventListener("focus", () => {
        inputArea.classList.add("focus");
    });

    input.addEventListener("blur", () => {
        inputArea.classList.remove("focus");
    });

    inputArea.classList.toggle("typed", !!input.value.length);

    if (input.value) {
        inputArea.classList.toggle("invalid", !input.validity.valid);
    }

    input.addEventListener("input", () => {
        inputArea.classList.toggle("typed", !!input.value.length);
    });
});

Array.from(showPasswordCheckboxes).forEach(showPasswordCheckbox => {
    showPasswordCheckbox.addEventListener("change", () => {
        const passwordInput = showPasswordCheckbox.parentElement.parentElement.querySelector("input");
        passwordInput.type = showPasswordCheckbox.checked ? "text" : "password";
    });
});
